// Author XXL
// Date 2021-03-19 18:16:53

class SithMesInventoryReceiveErrorType {
constructor({
        id = null,
        sequence = '',
        type = '',
        remark = ''}
= {}) {
    this.id = id;
    this.sequence = sequence;
    this.type = type;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryReceiveErrorType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'sequence',
        label: 'label.sith.inventory.sithMesInventoryReceiveErrorType.grid.sequence',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'type',
        label: 'label.sith.inventory.sithMesInventoryReceiveErrorType.grid.type',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryReceiveErrorType.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    sequenceFilter : "",
    typeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sequenceFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiveErrorType.filter.sequence',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'typeFilter',
        label: 'label.sith.inventory.sithMesInventoryReceiveErrorType.filter.type',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'sequence',
        label: 'label.sith.inventory.sithMesInventoryReceiveErrorType.entity.sequence',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'type',
        label: 'label.sith.inventory.sithMesInventoryReceiveErrorType.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryReceiveErrorType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesInventoryReceiveErrorType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
